<app-top-menu (userInfoLoaded)="userInfoLoaded($event)" (toggleSidebar)="toggleSidebar()"></app-top-menu>

<div id="home-wrapper" [ngClass]="{'active':isSidenavActive}">
    <div id="side-nav" *ngIf="isMenu">
        <app-side-nav [menuItems]="roleMenuitems" (toggleSidebar)="toggleSidebar()"></app-side-nav>
    </div>
    <div id="main-content" class="container-fluid">
        <router-outlet></router-outlet>
    </div>
</div>
<div>
    <app-footer class="footer"></app-footer>

</div>

<div class="info-popup" style="width:315px;" *ngIf="waiting_room_CheckIn">
    <audio control loop id="audio" src="../../assets/sounds/video-call-alert.wav" autoplay="true"></audio>

    <div style="margin:12px;">
        <div style="margin-left:10px;">
            <div>A new {{ClientLabel | lowercase}} ( {{patientname}} ) has been checked in to the waiting room. Please
                check.</div>
        </div>
        <div style="margin-top: 10px;margin-left: 10px;">
            <button style="width:100px;display: inline-block;margin-top:0px;"
                class="btn btn-apportis-primary-theme btn-block" (click)="confirmWaitingRoomCheckIn()">{{'Ok' |
                translateOrgSpecific}}</button>

        </div>
    </div>
</div>
<app-msg-box #msgbox></app-msg-box>